import { Fieldset } from "nhsuk-react-components"
import { ModifiablePenToolProperties } from "../../../../lib/editor/tools/PenTool"
import { ButtonGroup } from "../../../common/ButtonGroup"
import { useCallback } from "react"
import { LineTool } from "../../../../lib/editor/tools/LineTool"
import { useEditor } from "../../../../lib/hooks/useEditor"

type LineToolControllerProps = {
  lineTool: LineTool;
}

export const LineToolController = ({ lineTool }: LineToolControllerProps) => {
  const editor = useEditor();

  const onStrokeColorSelect = useCallback((strokeColor: string) => {
    editor.store.updateActiveToolProps<Partial<ModifiablePenToolProperties>>({
      strokeColor
    });
  }, [editor]);

  const onStrokeSizeSelect = useCallback((strokeSize: string) => {
    editor.store.updateActiveToolProps<Partial<ModifiablePenToolProperties>>({
      strokeSize: parseInt(strokeSize)
    });
  }, [editor]);

  return (
    <>
      {lineTool.controlMap.strokeColor.type === 'choices' ? (
        <Fieldset>
          <Fieldset.Legend>Border color:</Fieldset.Legend>

          <ButtonGroup
            variant="color"
            onSelect={onStrokeColorSelect}
            selectedOptionValue={lineTool.properties.strokeColor}
            options={lineTool.controlMap.strokeColor.options.map((strokeColorOption) => ({
              name: strokeColorOption.label,
              value: strokeColorOption.value
            }))}
          />
        </Fieldset>
      ) : null}

      {lineTool.controlMap.strokeSize.type === 'choices' ? (
        <Fieldset>
          <Fieldset.Legend>Border size:</Fieldset.Legend>

          <ButtonGroup
            variant="size"
            onSelect={onStrokeSizeSelect}
            selectedOptionValue={lineTool.properties.strokeSize.toString()}
            options={lineTool.controlMap.strokeSize.options.map((strokeSizeOption) => ({
              name: strokeSizeOption.label,
              value: strokeSizeOption.value,
              color: editor.store.activeTool?.properties.strokeColor
            }))}
          />
        </Fieldset>
      ) : null}
    </>
  )
}
